export default {
  categoryButton: 'category-button',
  selectedCategoryTitle: 'selected-category-title',
  planCardCategory: 'plan-card-category',
  planCard: 'plan-card',
  planCardTitle: 'plan-card-title',
  planCardDescription: 'plan-card-description',
  planCardShareButton: 'plan-card-share-button',
  planCardShareButtonLabel: 'plan-card-share-button-label',
};
